import React from 'react'
import Typography from '@material-ui/core/Typography'
import Page from 'components/layout/Page'

const Contact = ({

}) => {
  return (
    <Page>
      <Typography gutterBottom>
        Get in touch to ask questions, or enquire about our on-prem/enterprise offering.
      </Typography>
      <Typography gutterBottom>
        email: <strong>info@testfaster.ci</strong>
      </Typography>
    </Page>
  )
}

export default Contact